import React from 'react';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';

import './SignupCheckEmail.scss';
import checkEmailUrl from './check_email_desktop.png';

function OpenLinkOnDesktop() {
  return (
    <div className="signup-check-email d-flex flex-column w-100">
      <div className="signup-check-email-body d-flex align-items-center justify-content-center w-100 h-100">
        <div className="signup-check-email-content d-flex flex-column align-items-center justify-content-center w-100 pt-5 pb-4 px-4">
          <CharmaLogo type="icon" width="55" className="mb-3" />
          <div className="signup-check-email-title text-center mb-3">
            Sorry, this link won&#39;t work on a phone or tablet.
          </div>
          <div className="d-flex py-2 mb-4 mt-3">
            <img src={checkEmailUrl} alt={checkEmailUrl} width="142" />
          </div>
          <div className="signup-check-email-section text-center mb-4">
            Please open the link on a <b>laptop or desktop</b> computer to finish signing up.
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpenLinkOnDesktop;
